import LegalPageLayout from '../components/LegalPageLayout';

export default function PrivacyPage() {
  const sections = [
    {
      title: 'Giriş',
      content: <p><strong className="text-white">Medyatik Interactive</strong> olarak, gizliliğinize saygı duyuyor ve kişisel verilerinizin korunmasına büyük önem veriyoruz. Bu Gizlilik Politikası, web sitemizi ziyaret ettiğinizde hangi bilgileri topladığımızı, bu bilgileri nasıl kullandığımızı ve koruduğumuzu açıklamaktadır.</p>,
    },
    {
      title: 'Toplanan Bilgiler',
      content: (
        <ul className="list-disc pl-5 space-y-1">
          <li><strong className="text-zinc-300">Kişisel Bilgiler:</strong> İletişim formunu doldurduğunuzda sağladığınız ad, e-posta, telefon numarası ve şirket bilgileri</li>
          <li><strong className="text-zinc-300">Kullanım Verileri:</strong> IP adresi, tarayıcı türü, ziyaret edilen sayfalar, ziyaret süresi</li>
          <li><strong className="text-zinc-300">Çerez Verileri:</strong> Tercihlerinizi hatırlamak ve site deneyimini iyileştirmek için kullanılan çerezler</li>
        </ul>
      ),
    },
    {
      title: 'Bilgilerin Kullanımı',
      content: (
        <ul className="list-disc pl-5 space-y-1">
          <li>İletişim taleplerinizi yanıtlamak</li>
          <li>Hizmetlerimiz hakkında bilgi sağlamak</li>
          <li>Web sitesi performansını analiz etmek ve iyileştirmek</li>
          <li>Güvenlik önlemleri almak</li>
          <li>Yasal yükümlülüklerimizi yerine getirmek</li>
        </ul>
      ),
    },
    {
      title: 'Çerezler (Cookies)',
      content: (
        <>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong className="text-zinc-300">Zorunlu Çerezler:</strong> Web sitesinin düzgün çalışması için gerekli çerezler</li>
            <li><strong className="text-zinc-300">Analitik Çerezler:</strong> Ziyaretçi davranışlarını anlamamıza yardımcı olan çerezler</li>
            <li><strong className="text-zinc-300">Tercih Çerezleri:</strong> Dil ve bölge tercihlerinizi hatırlayan çerezler</li>
          </ul>
          <p>Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz, ancak bu bazı site özelliklerinin çalışmamasına neden olabilir.</p>
        </>
      ),
    },
    {
      title: 'Bilgi Paylaşımı',
      content: <p>Kişisel bilgilerinizi üçüncü taraflarla satmıyor veya kiralamıyoruz. Bilgileriniz yalnızca hizmet sağlayıcılarımızla (hosting, e-posta servisleri vb.) ve yasal zorunluluk halinde yetkili makamlarla paylaşılabilir.</p>,
    },
    {
      title: 'Veri Güvenliği',
      content: <p>Kişisel verilerinizi korumak için endüstri standardı güvenlik önlemleri uyguluyoruz. Ancak, internet üzerinden veri iletiminin %100 güvenli olmadığını ve mutlak güvenliği garanti edemeyeceğimizi belirtmek isteriz.</p>,
    },
    {
      title: 'Üçüncü Taraf Bağlantılar',
      content: <p>Web sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu sitelerin gizlilik uygulamalarından sorumlu değiliz ve ziyaret etmeden önce kendi gizlilik politikalarını incelemenizi öneririz.</p>,
    },
    {
      title: 'Çocukların Gizliliği',
      content: <p>Web sitemiz 18 yaşın altındaki bireylere yönelik değildir. Bilerek 18 yaşın altındaki bireylerden kişisel bilgi toplamıyoruz.</p>,
    },
    {
      title: 'Politika Değişiklikleri',
      content: <p>Bu Gizlilik Politikası'nı zaman zaman güncelleyebiliriz. Önemli değişiklikler olması durumunda web sitemizde duyuru yapacağız.</p>,
    },
    {
      title: 'İletişim',
      content: <p><strong className="text-zinc-300">E-posta:</strong> info@medyatik.app<br /><strong className="text-zinc-300">Adres:</strong> Esentepe Mah. Talatpaşa Cad. No: 5/1, 34394 Şişli/İstanbul<br /><strong className="text-zinc-300">Telefon:</strong> +90 532 168 62 82</p>,
    },
  ];

  return <LegalPageLayout title="Gizlilik Politikası" date="Son Güncelleme: Aralık 2024" sections={sections} testId="privacy-page" />;
}
